import { useEffect, useState } from 'react';
import AnimatedNumber from 'react-animated-number';
import styles from './event-banner.module.less';
import { ContentTitle } from '../../components/typography/Heading';
import Image from '../../components/image/Image';
import { formatMoneyKr, formatNumber } from '../../utils';
import LoaderBar from '../../components/loader-bar/LoaderBar';
import { useDispatch } from 'react-redux';
import { fetchEventStats, fetchEventStatsBySchool } from '../../event/event-actions';
import ThemeContainer from '../../components/theme-container/ThemeContainer';
import ThemeContext from '../../context/theme-context';
import { Heading2 } from '@sb1/ffe-core-react';

const EventBanner = ({
    eventId,
    schoolOrgNumber,
    title,
    numberOfProjectsIllustration,
    numberOfProjectsText = 'spleiser',
    numberOfGiversIllustration = 'illustrations/heart_in_hand.svg',
    numberOfGiversText = 'givere',
    collectedAmountIllustration,
    collectedAmountText = 'totalt innsamlet',
    theme,
}) => {
    const dispatch = useDispatch();
    const [projectCount, setProjectCount] = useState(0);
    const [amountCollected, setAmountCollected] = useState(0);
    const [giverCount, setGiverCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const setStateFromResponse = (res) => {
        setProjectCount(parseInt(res.body.project_count, 10));
        setAmountCollected(parseInt(res.body.collected_amount, 10));
        setGiverCount(parseInt(res.body.giver_count, 10));
    };

    useEffect(() => {
        setLoading(true);
        if (schoolOrgNumber) {
            dispatch(fetchEventStatsBySchool({ eventId, schoolOrgNumber }))
                .then((res) => setStateFromResponse(res))
                .finally(() => setLoading(false));
        } else {
            dispatch(fetchEventStats({ eventId }))
                .then((res) => setStateFromResponse(res))
                .finally(() => setLoading(false));
        }
    }, [eventId, schoolOrgNumber]);

    if (loading) {
        return <LoaderBar />;
    }

    return (
        <ThemeContext.Provider value={{ theme }}>
            <ThemeContainer className={styles.container}>
                {title && <Heading2>{title}</Heading2>}
                <div className={styles.numberWrapper}>
                    <div className={styles.numberContainer}>
                        <div className={styles.number}>
                            {numberOfProjectsIllustration && (
                                <Image className={styles.icon} src={numberOfProjectsIllustration} alt={''} />
                            )}
                            <AnimatedNumber
                                duration={3000}
                                className={styles.numberTitle}
                                value={projectCount}
                                formatValue={formatNumber}
                            />
                        </div>
                        <span className={styles.numberDescription}>{numberOfProjectsText}</span>
                    </div>
                    <div className={styles.numberContainer}>
                        <div className={styles.number}>
                            {numberOfGiversIllustration && (
                                <Image className={styles.icon} src={numberOfGiversIllustration} alt={''} />
                            )}
                            <AnimatedNumber
                                duration={3000}
                                className={styles.numberTitle}
                                value={giverCount}
                                formatValue={formatNumber}
                            />
                        </div>
                        <span className={styles.numberDescription}>{numberOfGiversText}</span>
                    </div>
                    <div className={styles.numberContainer}>
                        <div className={styles.number}>
                            {collectedAmountIllustration && (
                                <Image className={styles.icon} src={collectedAmountIllustration} alt={''} />
                            )}
                            <AnimatedNumber
                                duration={3000}
                                className={styles.numberTitle}
                                value={amountCollected}
                                formatValue={formatMoneyKr}
                            />
                        </div>
                        <span className={styles.numberDescription}>{collectedAmountText}</span>
                    </div>
                </div>
            </ThemeContainer>
        </ThemeContext.Provider>
    );
};

export default EventBanner;
